export const CURRENT_VALUE = Symbol('current-value')
export const SET_CURRENT_VALUE = Symbol('set-current-value')
export const SET_ITEM_SIZE = Symbol('set-item-size')
